var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.685,
    height: 111.105,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.13,
    x2: 0.796,
    y1: 0.12,
    y2: 0.782,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#387eb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.191,
    x2: 0.907,
    y1: 0.206,
    y2: 0.884,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc331"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M55.585.072C27.233.072 29 12.367 29 12.367l.031 12.738h27.06v3.825h-37.8S.145 26.873.145 55.48s15.836 27.595 15.836 27.595h9.451V69.8s-.509-15.836 15.583-15.836h26.834s15.077.244 15.077-14.571V14.9S85.216.072 55.585.072ZM40.666 8.638a4.863 4.863 0 1 1-3.443 1.424 4.863 4.863 0 0 1 3.443-1.424Z",
    "data-name": "Path 284",
    transform: "translate(-.145 -.072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M93.526 147.328c28.353 0 26.583-12.3 26.583-12.3l-.031-12.738H93.021v-3.82h37.8s18.143 2.058 18.143-26.551-15.836-27.594-15.836-27.594h-9.448V77.6s.509 15.836-15.583 15.836H81.262s-15.077-.244-15.077 14.572v24.5s-2.285 14.82 27.341 14.82Zm14.919-8.565a4.864 4.864 0 1 1 3.443-1.425 4.863 4.863 0 0 1-3.443 1.425Z",
    "data-name": "Path 285",
    transform: "translate(-37.281 -36.223)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.15c0e11516554770166411058266246a.svg";
export { ForwardRef as ReactComponent };